import template from './template.vue'

const Preview = {
  name: 'Preview',
  install (Vue, options) {
    console.log(options)
    // 调用方法
    Vue.prototype.$preview = {
      // 预览图片
      showImg (urlStr) {
        Preview.createElement(Vue, urlStr, 'image')
      },
      // 预览视频
      showVideo (urlStr) {
        Preview.createElement(Vue, urlStr, 'video')
      }
    }
  },
  // 创建虚拟节点
  createElement (Vue, urlStr, typeStr) {
    const props = {
      url: urlStr,
      type: typeStr
    }
    const vm = new Vue({
      // 为什么不使用 template 要使用render 因为现在是webpack里面没有编译器 只能使用render
      // render: h => h (component, {props})  // render 生成虚拟dom  {props: props}
      render: function (h) {
        return h(template, {
          props
        })
      }
    }).$mount() // $mount 生成真实dom, 挂载dom 挂载在哪里, 不传参的时候只生成不挂载，需要手动挂载
    // 将el挂载到body中
    document.body.appendChild(vm.$el)
  }
}
export default Preview



// WEBPACK FOOTER //
// ./src/components/webpc/Preview/index.js